import { render, staticRenderFns } from "./RosterSwaps.vue?vue&type=template&id=0ca0c618"
import script from "./RosterSwaps.vue?vue&type=script&lang=js"
export * from "./RosterSwaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports